import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getRoleDetails = createAsyncThunk("role/getRoleDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getRoleDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
